/**
 * NFC tag admin is a district admin screen. It is shown only when the
 * district flag attendance.ota_opt2.nfc_tap is on. A missing flag is off.
 * The caller's union does not matter here; the phone tap uses that check.
 * A tap does not replace GPS. This screen does not take photos.
 */

export const NFC_TAP_FLAG = 'attendance.ota_opt2.nfc_tap';
export const NFC_TAG_PERMISSION = 'attendance.nfc_tags.view';
export const NFC_TAG_EDIT_PERMISSION = 'attendance.nfc_tags.edit';
export const NFC_TAGS_HREF = '/attendance/nfc-tags';
export const WALL_TAG_PLACEMENT = (
  'One fixed site tag on the wall next to the badge reader at '
  + '55 Stonehill Road, Oswego, IL 60543.'
);

export function nfcTagFlagOn(flagPayload) {
  const keys = flagPayload && Array.isArray(flagPayload.keys) ? flagPayload.keys : [];
  return keys.includes(NFC_TAP_FLAG);
}

/**
 * Menu visibility. The flag stays off for super admins too.
 * They still need the flag on; the permission check is the only bypass.
 */
export function nfcTagNavVisible({ flagOn, permissions, isSuperAdmin } = {}) {
  if (!flagOn) return false;
  if (isSuperAdmin) return true;
  return (permissions || []).includes(NFC_TAG_PERMISSION);
}
